import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddNew16 } from 'ui/icons/aurora';
import { PrimaryButton } from 'ui/button';
import { Table } from 'ui/table';
import { PaginationFooter } from 'ui/paginationFooter';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { FlexSpacer } from 'ui/flexSpacer';
import { InputText } from 'ui/inputs/inputText';
import { ModalContextProvider } from 'utils/contexts/modal';
import { PageHeader } from 'ui/pageHeader';
import { fetchThirdPartyIntegrationsRequest } from '../actions';
import { selectThirdPartyIntegrations } from '../selectors';
import { ModernizedModals } from './ModernizedModals';
import { useModalsContext } from '../contexts';
import { COLUMNS } from '../constants';
import { thirdPartyTableFilterFn } from '../utils';

export const ThirdPartyIntegrations = () => {
  const thirdPartyIntegrations = useSelector(selectThirdPartyIntegrations);
  const {
    currentPage,
    itemsPerPage,
    numItems,
    rows,
    setCurrentPage,
    setItemsPerPage,
    setSortDirection,
    setSortedBy,
    sortDirection,
    sortedBy,
    filter,
    setFilter,
  } = useClientPaginatedState({
    rows: thirdPartyIntegrations,
    sortedBy: 'id',
    filterFn: thirdPartyTableFilterFn,
  });
  const { showCreateThirdPartyIntegrationModal } = useModalsContext();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchThirdPartyIntegrationsRequest());
  }, [dispatch]);

  return (
    <>
      <PageHeader
        documentation={{
          href: 'http://support.iterable.com/hc/en-us/articles/204795719-Integrating-with-Segment',
          content: 'Documentation',
        }}
        pageActions={
          <PrimaryButton
            data-test="pageHeaderPrimaryAction"
            onClick={showCreateThirdPartyIntegrationModal}
          >
            <AddNew16 />
            Add Segment integration
          </PrimaryButton>
        }
      >
        Third-Party Integrations
      </PageHeader>
      <FlexSpacer gap="actionGap" justifyContent="flex-end">
        <InputText
          data-test="filter-third-party-integrations"
          placeholder="Filter by..."
          value={filter}
          onChange={setFilter}
        />
      </FlexSpacer>
      <Table>
        <TableHeader
          columns={COLUMNS}
          setSortDirection={setSortDirection}
          setSortedBy={setSortedBy}
          sortDirection={sortDirection}
          sortedBy={sortedBy}
        />
        <TableRows columns={COLUMNS} rows={rows} />
      </Table>
      <PaginationFooter
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        onUpdate={({ page, pageSize }) => {
          setCurrentPage(page);
          setItemsPerPage(pageSize);
        }}
      />
      <ModernizedModals />
    </>
  );
};

export default () => (
  <ModalContextProvider>
    <ThirdPartyIntegrations />
  </ModalContextProvider>
);
